import { render } from "./VerifyView.vue?vue&type=template&id=98e56b84"
import script from "./VerifyView.vue?vue&type=script&lang=js"
export * from "./VerifyView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__